import { render, staticRenderFns } from "./campcCatalog.vue?vue&type=template&id=10561850&scoped=true"
import script from "./campcCatalog.vue?vue&type=script&lang=js"
export * from "./campcCatalog.vue?vue&type=script&lang=js"
import style0 from "./campcCatalog.vue?vue&type=style&index=0&id=10561850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10561850",
  null
  
)

export default component.exports